module.exports = __webpack_public_path__ + "static/media/filter.158ca158.svg";